<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Blog - seznam</strong>
      </div>
      <action-tools :router-options="routerOptions" :handle-refresh="handleRefresh"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <a-dropdown :placement="'bottomLeft'">
            <a-button>Hromadné akce
              <a-icon type="down"/>
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item :disabled="selectedRowKeys.length === 0" :class="{'disabled': selectedRowKeys.length === 0}">
                <a-popconfirm @confirm="confirmDelete(selectedRowKeys)" okText="Potvrdit" cancelText="Zrušit">
                  <template slot="title">
                    <p>Opravdu si přejete odstranit tyto položky?</p>
                    <div v-if="selectedRowKeys.length > 0">
                      {{ selectedRowKeys }}
                    </div>
                  </template>
                  Odstranit
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="text-right col-md-6">
          <a-input-search
            placeholder="Hledat..."
            style="width: 200px"
            @search="handleSearch"
          />
        </div>
      </div>
      <a-table
        tableLayout="auto"
        :rowSelection="rowSelection"
        :rowKey="record => record.blg_id"
        :columns="columns"
        :loading="loading"
        :dataSource="blogs"
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
      >
        <router-link
          slot="blg_id"
          slot-scope="value"
          class="utils__link--underlined"
          :to="'/blog/detail/'+value"
        >#<span v-if="searchText">
            <template
              v-for="(fragment, i) in value.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{value}}</template>
        </router-link>
        <template slot="customRender" slot-scope="text">
          <a-alert v-if="text === undefined" message="není nastaveno" type="warning" showIcon />
          <span v-else-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </template>
        <span
          slot="active"
          slot-scope="value"
          :class="[value === undefined ? '' : value ? 'font-size-12 badge badge-success' : 'font-size-12 badge badge-danger']"
        >
          <a-alert v-if="value === undefined" message="není nastaveno" type="warning" showIcon />
          <span v-else-if="searchText">
            <template
              v-for="(fragment, i) in (value ? 'ano' : 'ne').toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{value ? 'ano' : 'ne'}}</template>
        </span>
        <span slot="tags" slot-scope="record">
          <a-tag style="display: block;float:left;margin-bottom: 4px;" :color="tag.blog_tag_languages.length === 0 ? 'orange' : 'blue'" v-for="tag in record" :key="tag.tag_id">
            <template v-if="tag.blog_tag_languages.length === 0">není nastaveno</template>
            <span v-else-if="searchText">
              <template
                v-for="(fragment, i) in tag.blog_tag_languages[0].pivot.bte_name.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                >{{fragment}}</mark>
                <template v-else>{{fragment}}</template>
              </template>
            </span>
            <template v-else>{{tag.blog_tag_languages[0].pivot.bte_name}}</template>
          </a-tag>
        </span>
        <span slot="comments_count" slot-scope="text">
          <a-icon type="message" />&nbsp;&nbsp;
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </span>
        <span
          slot="image"
          slot-scope="record"
          :class="$style.thumbnail"
        >
          <img v-if="record !== null && !image.errors.includes(record.iae_id)" :src="$uploadImagePath + record.iae_path + '_10.' + record.iae_format" @error="image.errors.push(record.iae_id)">
          <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
        </span>
        <span
          slot="dates"
          slot-scope="text"
        >
          <a-alert v-if="text === undefined" message="není nastaveno" type="warning" showIcon />
        <span v-else-if="searchText">
            <template
              v-for="(fragment, i) in toLocaleDate(text).toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{toLocaleDate(text)}}</template>
        </span>
        <span slot="action" slot-scope="record">
          <router-link :to="'/blog/detail/'+record.blg_id">
            <a-button icon="search" size="small" class="mr-1">Zobrazit</a-button>
          </router-link>
          <a-popconfirm @confirm="confirmDelete([record.blg_id])" okText="Potvrdit" cancelText="Zrušit">
            <template slot="title">
                <p>Opravdu si přejete odstranit položku: #{{ record.blg_id }} ?</p>
            </template>
            <a-button icon="delete" size="small">Odstranit</a-button>
          </a-popconfirm>
        </span>
        <template slot="footer">
          {{ blogs.length }} položek
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'

export default {
  components: { ActionTools, LanguageTab },
  data: function () {
    return {
      image: {
        errors: [],
      },
      searchText: '',
      loading: false,
      selectedRowKeys: [],
      routerOptions: [
        {
          icon: 'plus-circle',
          to: '/blog/add',
          title: 'Přidat',
        },
      ],
      columns: [
        {
          title: 'ID',
          dataIndex: 'blg_id',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.blg_id - b.blg_id,
          scopedSlots: {
            customRender: 'blg_id',
          },
        },
        {
          title: 'Obrázek',
          dataIndex: 'image',
          scopedSlots: {
            customRender: 'image',
          },
        },
        {
          title: 'Název',
          dataIndex: 'languages[0].pivot.ble_name',
          sorter: (a, b) => {
            return a.languages.length > 0 && b.languages.length > 0 ? a.languages[0].pivot.ble_name.localeCompare(b.languages[0].pivot.ble_name) : 0
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Kategorie',
          dataIndex: 'blog_category.languages[0].pivot.bce_name',
          sorter: (a, b) => {
            return a.blog_category.length > 0 && b.blog_category.length > 0 ? a.blog_category.languages[0].pivot.bce_name.localeCompare(b.blog_category.languages[0].pivot.bce_name) : 0
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Štítky',
          dataIndex: 'tags',
          scopedSlots: {
            customRender: 'tags',
          },
        },
        {
          title: 'Poslední úprava',
          dataIndex: 'languages[0].pivot.updated_at',
          sorter: (a, b) => a.languages.length > 0 && b.languages.length > 0 ? new Date(a.languages[0].pivot.updated_at) - new Date(b.languages[0].pivot.updated_at) : 0,
          scopedSlots: {
            customRender: 'dates',
          },
        },
        {
          title: 'Zveřejněno',
          dataIndex: 'languages[0].pivot.ble_is_active',
          sorter: (a, b) => a.languages.length > 0 && b.languages.length > 0 ? a.languages[0].pivot.ble_is_active - b.languages[0].pivot.ble_is_active : 0,
          scopedSlots: {
            customRender: 'active',
          },
        },
        {
          title: 'Počet komentářů',
          dataIndex: 'comments_count',
          sorter: (a, b) => a.comments_count - b.comments_count,
          scopedSlots: {
            customRender: 'comments_count',
          },
        },
        {
          title: 'Akce',
          key: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
    }
  },
  computed: {
    blogs: function () {
      return this.$store.getters['blog/currentLanguage'](this.searchText)
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        selections: [{
          key: 'all-data',
          text: 'Vybrat všechny položky',
          onSelect: () => {
            this.selectedRowKeys = this.selectedRowKeys.length === 0 ? this.blogs.map(item => item.blg_id) : []
          },
        }],
        onSelection: this.onSelection,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleRefresh() {
      this.loading = true
      this.$store.dispatch('blog/getList')
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    confirmDelete(blogs) {
      this.loading = true
      this.$store.dispatch('blog/delete', blogs)
        .then(() => {
          if (this.selectedRowKeys.length > 0) {
            this.selectedRowKeys = blogs.filter(x => !this.selectedRowKeys.includes(x))
              .concat(this.selectedRowKeys.filter(x => !blogs.includes(x)))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch(searchText) {
      this.searchText = searchText
    },
    toLocaleDate: function (text) {
      return this.$options.filters.formatDate(text)
    },
  },
  created() {
    if (this.blogs.length === 0 && this.$store.getters['language/active'] !== null) {
      this.handleRefresh()
    }
    this.$store.watch(
      (state, getters) => getters['language/active'], () => {
        if (this.$store.getters['language/active'] !== null && this.blogs.length === 0) {
          this.handleRefresh()
        }
      },
    )
  },
}
</script>

<style lang="scss" module scoped>
  @import "./style.module.scss";
</style>
